import React, { Component } from 'react'
import { Row, Content } from '../components/Layout.js'

class NotFound extends Component {
  render () {
    return (
      <section id='notfound'>
        <Row>
          <Content classes={['contentFull']}>
            <i className='ac ac-pants' />
            <h1>404</h1>
            <p>Oh pants, that's embarrassing! Check the URL again, if it's a total wedgie try untangling yourself by going home.</p>
            <a href='/' className='button button-primary' rel='noopener'>Go Home</a>
          </Content>
        </Row>
      </section>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/containers/NotFound.js